import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box } from "@mui/system";

const AlertDialog = ({
  open,
  onClose,
  handleClose,
  title,
  description,
  icon,
  buttonText = "Close",
}) => {
  const closeHandler = onClose || handleClose;
  const IconComponent = icon || WarningAmberIcon;
  return (
    <Dialog open={open} onClose={closeHandler}>
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "5px" }}>
        <IconComponent color="error" fontSize="large" />
      </Box>
      <DialogTitle sx={{ display: "flex", justifyContent: "center" }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "center", marginBottom: "5px" }}>
        <Button
          variant="outlined"
          sx={{ width: "95%", textTransform: "none" }}
          onClick={closeHandler}
        >
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;